var n = /* @__PURE__ */ ((o) => (o.onClick = "onClick", o.onContextMenu = "onContextMenu", o.onDoubleClick = "onDoubleClick", o.onPointerUp = "onPointerUp", o.onPointerDown = "onPointerDown", o.onPointerOver = "onPointerOver", o.onPointerOut = "onPointerOut", o.onPointerEnter = "onPointerEnter", o.onPointerLeave = "onPointerLeave", o.onPointerMove = "onPointerMove", o.onPointerCancel = "onPointerCancel", o))(n || {});
export {
  n as RgEvents
};
//# sourceMappingURL=index.js.map
